import { render } from "./UploadUrlModal.vue?vue&type=template&id=16001af2&scoped=true"
import script from "./UploadUrlModal.vue?vue&type=script&lang=js"
export * from "./UploadUrlModal.vue?vue&type=script&lang=js"

import "./UploadUrlModal.vue?vue&type=style&index=0&id=16001af2&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16001af2"]])

export default __exports__